import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import HomeIndex from './Components/HomePage/HomeIndex';
import CommitteIndex from './Components/Committe/CommitteIndex';
function App() {
  return (
  <Routes>
    <Route path="/" element={<HomeIndex />} />
    <Route path="/committe" element={<CommitteIndex />} />
  </Routes>
  );
}

export default App;
